import { Component, signal, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App implements OnInit {
  showSplash = signal(true);
  fadingOut = signal(false);

  ngOnInit() {
    setTimeout(() => {
      this.fadingOut.set(true);
      setTimeout(() => this.showSplash.set(false), 500);
    }, 1000);
  }
}
